import { forkJoin, Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ProjectGlobalInfoModel } from 'src/app/shared/model/project-global-info.model';
import { AdminManagementService } from '@projects/user-management/src/app/user/service/admin-management.service';
import { CreateProjectService } from '@projects/create-project/src/app/create-project/create-project.service';
import { Component, OnInit, Inject, ViewEncapsulation, Renderer2, OnDestroy, Pipe, Input} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { SharedService } from '../../services/shared.service';
import { ToolsAcceleratorsControlsService } from '@projects/trainstops/src/app/services/tools-accelerators-controls.service';
import { switchMap } from 'rxjs/operators';

import {
  CommonDialogueBoxData,
  DELETE_ALL_NOTIFICATIONS,
  EC_TITLE,
  SO_TITLE,
  TestAI_TITLE,
  validationMessages,
  DOWNLOAD_REPORTS,
  REPORT_DEFAULT_MIN_DATE,
  REPORT_DEFAULT_MAX_DATE,
  SELECT_TYPE_STATUS,
  IDocumentUrl,
  IOfferingPortfolio,
  IOfferingPortfolioResponse,
  ISourceOfferingResponse,
  ISourceOffering,
  IPackageResponse,
  IPackageData,
  IPrePackageData,
  IPrePackageResponse,
  USER_PREFERENCES,
} from "../../constants/common-dialogue-box";
import { KeyValue, Location } from '@angular/common';
import { Router } from '@angular/router';
import { UserPreferenceService } from 'src/app/shared/services/user-preferences.service';
import { PassGlobalInfoService } from '../../services/pass-project-global-info.service';
import { CryptUtilService } from '../../services/crypt-util.service';
import { HttpHeaders } from '@angular/common/http';
import { MyProjectsService } from '@projects/workspace/src/app/my-projects/my-projects.service';
import { SitemapService } from '@projects/sitemap/src/app/sitemap/sitemap.service';
import { UserRoleAssociationDetails } from '../../model/project-global-info.model';
import { PROJECT_USERS_DELETE } from './common-dialogue-box.constants';
import { EC_SYNC_INFO_POPUP, EC_SYNC_STATUS_COLOR_CODE_MAP } from '@projects/psg/src/app/core/utility/constants';
import { ALM, DTAPP_FEATURE_KEYS, ENTERPRISE_CONSCIOUSNESS, JIRA, MS_TEAMS, SMART_OFFERING, Smart_PMO, TEST_AI, TEST_AI_PROVISION_TITLE, SAP_CALM } from '@projects/trainstops/src/app/core/utility/constants'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { ActivitiesGlobalContextService } from '@projects/trainstops/src/app/feature/activities/activities-global-context.service';
import { formatDate } from '@angular/common';
import { LANGUAGE_DATA } from '../../../../../projects/psg/src/app/core/utility/constants';
import {
  FormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { map, startWith } from 'rxjs/operators';
import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { saveAs } from 'file-saver';
import { PROJECT_STATUS } from '@projects/shared-lib/src/public-api';
import { US_REGION } from '@projects/create-project/src/app/project-creation-intial/create-project-constants';
import { GlobalInstancesService } from '@projects/shared-lib/src/lib/services/global-instances.service';
import { USERROLES } from '@projects/shared-lib/src/lib/utility/constants';
export enum CriticalPath {
  Core = 1,
  Alternate = 2
}

@Component({
    selector: 'app-common-dialogue-box',
    templateUrl: './common-dialogue-box.component.html',
    styleUrls: ['./common-dialogue-box.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: NativeDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: { parse: { dateInput: 'MM/DD/YYYY' }, display: { dateInput: 'MM/DD/YYYY', monthYearLabel: 'MMM YYYY', dateA11yLabel: 'MM/DD/YYYY', monthYearA11yLabel: 'MMMM YYYY' } } },
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CommonDialogueBoxComponent implements OnInit, OnDestroy {

  userInfo: UserRoleAssociationDetails;
  hideApplyBtn: boolean = false;
  hideCancelBtn: boolean = false;
  Test_AI_PROVISION_TITLE = TEST_AI_PROVISION_TITLE;
  dialogMessage: any;
  userPrefDataFound: boolean = false;
  noPublishedPackage: boolean = true;
  noOfferings: boolean = false;
  isDataFetchingInProgress: boolean = false;
  showLoader : boolean = false;
  resetValues : boolean = false;
  noPublishedPkgMsg: any;
  noOfferingsMsg: any;
  isProjectUser:boolean;
  projectGlobalInfo: ProjectGlobalInfoModel = new ProjectGlobalInfoModel();
  globalSubscription: Subscription[] = [];
  parentId: number;
  ecTitle = EC_TITLE;
  soTitle = SO_TITLE;
  testAITitle = TestAI_TITLE;
  EC_SYNC_INFO_POPUP = EC_SYNC_INFO_POPUP;
  EC_SYNC_STATUS_COLOR_CODE_MAP = EC_SYNC_STATUS_COLOR_CODE_MAP;
  reportPollingTimer: any;
  languageId: number = 1;
  msTeamsChannelTypes:{id:string ,name: string,selected :boolean}[] = [];
  myControl = new FormControl();
  msTeamsChannels: string[] = [];
  groupChannelId :string;
  ishidden:boolean = false;
  isDropdownOpen:boolean = false;
  ownedChannels:   {id:string ,channel: string}[] = [];
  filteredChannels: string[] = [];
  filteredChannelsMsSweep: string[] = [];
  channelType:string;
  selectedMsChannel:string;
  channelForm: UntypedFormGroup;
  isChannelSelected:boolean = true;
  ascendGenerativeAISize: string;
  sourceTeamName: string;
  isMoreThan10GB: boolean = false;
  IsCurrentMSTeamsOwner :boolean = true;
  IsTargetSiteOwner :boolean = true;
  isManualCopy : boolean = false;
  isDataMigrated: boolean = false;
  isDataMigratedConfirm: boolean = false;
  transferDataFromMsTeamName: string;
  transferDataToMsTeamName: string;
  currentGroupId: string;
  targetGroupId : string;
  IsGenerativeAIFolderFound : boolean = false;
  manualUrl: string;
  isManualUrl = false;
  fileName: string;
  ascendContentSize: string;
  isAIPEnabled: boolean = false;
  isPortfolio: boolean = false;
  isOffering: boolean = false;
  offeringData: ISourceOffering[];
  filteredPortfolio: IOfferingPortfolio[];
  packageByOffering: IPackageData[];
  isAscendContentDeliverableTemplateFolderFound: boolean = false;
  isRequestDisabled: boolean = false; // Store the disable state
  EC = ENTERPRISE_CONSCIOUSNESS;
  msTeams = MS_TEAMS;
  SmartPMO = Smart_PMO;
  Jira = JIRA;
  ALM = ALM;
  TestAI = TEST_AI;
  SMART_OFFERING = SMART_OFFERING;
  SAPCALM = SAP_CALM;
  current_instance: any;
  primaryRedirectionUrl: any;
  globalDetailsSubs: Subscription;
  projectPackagesAndStatus = {
    typeOfReports: { data: [], currentSelected: '' },
    dateRangeOfReports: { data: ['All', 'Custom date'], currentSelected: 'All',tooltips: ['All the projects exist in ascend','Reports will be generated with projects which has start date within this date range'] },
    statusOfProjects: {
      allCompleted: false,
      projectStatus: []
    },
    packages: {
      allCompleted: true,
      packageList: []
    },
    selectedStartDate: '',
    selectedEndDate: '',
    enableDownloadButton: false,
    currentValidationError: "",
    minDate: REPORT_DEFAULT_MIN_DATE,
    maxDate: REPORT_DEFAULT_MAX_DATE,
    startDate: {minDate:  REPORT_DEFAULT_MIN_DATE, maxDate: REPORT_DEFAULT_MAX_DATE},
    endDate: {minDate: REPORT_DEFAULT_MIN_DATE, maxDate: REPORT_DEFAULT_MAX_DATE},
    currentPackage: ['projectPackagesAndStatus.packages.allCompleted'],
    currentStatus: ['projectPackagesAndStatus.statusOfProjects.allCompleted']
  }
  masterUserRoledata = [];
  portFolioId: number | null = null;
  offeringId: number | null = null;
  form: FormGroup;
  selectOfferingCopy: string[] = [];
  criticalPath = CriticalPath;
  l1Code: number;
  l2Code: number;
  openSelectState: {[key: string]: boolean} = {};
  isPackageAdmin:boolean = true;
  isPackageAdminOfferingMappingError:boolean = false;
  packageAdminPackageId = 0;
    AutoAppProvisionFeatureFlagJira = false;
  AutoAppProvisionFeatureFlagPmOne = false;
  AutoAppProvisionFeatureFlagAlm = false;
  isMasterProject: boolean;
  constructor(
    public dialogRef: MatDialogRef<CommonDialogueBoxComponent>,
    private sharedService: SharedService,
    private toolsAcceleratorsControlsService: ToolsAcceleratorsControlsService,
    private userPreference: UserPreferenceService,
    public router: Router,
    public renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) public data: CommonDialogueBoxData,
    private location: Location,
    private globalData: PassGlobalInfoService,
    private cryptUtilService: CryptUtilService,
    private myProjectsService: MyProjectsService,
    public createProjServ: CreateProjectService,
    private sitemapService: SitemapService,
    private adminManagementService: AdminManagementService,
    public globalContext: ActivitiesGlobalContextService,
    private formBuilder: UntypedFormBuilder,
    private globalInstancesService: GlobalInstancesService,
    private fb: FormBuilder,
    private translate: TranslateService
  ) {
    // this.userPreference.getUserPrefData().subscribe((data) => {
    //   this.data.userPrefPackage = data.packageName;
    //   this.data.userPrefFunction = data.functionName;
    // });
    this.renderer.removeClass(document.body, 'cdk-top');
    this.form = this.fb.group({
      portfolio: [{ value: "", disabled: false }],
      offering: [{ value: "", disabled: true }],
    });

    this.form.get("portfolio").valueChanges.subscribe((value: string) => {
      if (value && this.resetValues) {
        this.form.get("offering").enable();
        this.form.get("offering").setValue("");
        this.resetPackage();
        this.resetMethodAndFunction();
      }
    });

    this.form.get("offering").valueChanges.subscribe((value: string) => {
      if (value && this.resetValues) {
        this.resetPackage();
        this.resetMethodAndFunction();
        this.data.selectedOffering = this.selectOfferingCopy;
        this.noOfferings = false;
      }
    });
            DTAPP_FEATURE_KEYS.forEach(key =>{
          const value = this.sharedService.getFeatureConfiguration(key);
        this[key] = value === true || value === 'true';
        })

  this.isMasterProject = this.cryptUtilService.getItem('isMasterProject', 'LOCAL');

  }

  ngOnInit() {
    
    if (this.data.from == 'USER_PREFERENCES') {
        this.globalSubscription.push(
          this.userPreference.getUserRoleInfo(this.data.userId).subscribe((user_role:any) => {
            this.isPackageAdmin = Boolean(user_role.data.isPackageAdmin)
          })
        )
    }

    this.globalDetailsSubs = this.globalInstancesService.getCurrentGlobalInstance().subscribe((data) => { 
      if(data) {
          this.current_instance = data?.current_instance;
          this.primaryRedirectionUrl = data?.primaryRedirectionUrl;
      }
     });
    this.msTeamsChannelTypes.push({id:"1",name: 'Shared.CommonDialogBox.DeliveryTool.Dropdown.NewChannelSite',selected:true}) ;
    this.msTeamsChannelTypes.push({id:"2",name: 'Shared.CommonDialogBox.Label.MSTeamsSwap.TargetHeading',selected:false}) ;
    this.userPreference.getLanguageId().subscribe(id=>{
      this.languageId =id;
    })
    if(this.data.from=='MSTEAMS_SWAP')
    {
      this.isChannelSelected = false;
      this.getOwnedChannels();
      this.getSourceMSTeamsSize(this.data.projectId); // Example projectId

    }

    if(this.data.from=='MSTEAMS_SWAP_CONFIRMDATA')
    {
      this.getConfirmMsteamsData(this.data.projectId);
    }

    // if(this.data.from == 'REQUEST_TOOL')
    // {
    //   this.getTileIcon(this.data?.requestToolData?.title);
    // }

    this.globalSubscription.push(this.globalData.share.subscribe((info)=>{
      this.userInfo = info?.userRoleInfo;
     ///this.userInfo.role.isPackageAdmin = true;
    }));

    this.dialogRef.disableClose = true;
    if (this.data.from == "USER_PREFERENCES" || this.data.from == DOWNLOAD_REPORTS) {
      this.getPortFoliosList()
      if (this.router.url == '/welcome') {
        this.dialogMessage = this.data.messageText;
      }
      forkJoin({result: this.userPreference.getUserPreferencesData(this.data.userId), res: this.userPreference.getUserPackageOfferings(this.data.userId, this.languageId)}).subscribe(({result, res})=> {
        if (result && result?.data) {
          result.data.forEach(element => {
            this.data.userPrefPackage = element.package;
            this.data.userPrefFunction = element.functions;
            this.parentId = element.parent_package_id;
            this.cryptUtilService.setItem("Function-Value-UserPref", this.data.userPrefFunction, "SESSION");
            this.cryptUtilService.setItem("Function-Value-UserPref-Initial", this.data.userPrefFunction, "SESSION");
            this.cryptUtilService.setItem("Package-Value-UserPref", this.data.userPrefPackage, "SESSION");
            this.cryptUtilService.setItem("Package-Value-UserPref-Initial", this.data.userPrefPackage, "SESSION");
          });
            this.isPortfolio = Boolean(result?.data?.[0]?.portfolio_nm);
            if (!this.isPortfolio) {
              this.resetPackage();
              this.resetMethodAndFunction();
              this.resetValues = true;
            } else {
              this.resetValues = false;
              this.form
                .get("portfolio")
                .setValue(result?.data?.[0]?.portfolio_nm || "");
              this.findL1Code(result?.data?.[0]?.portfolio_nm);
            }

            this.isOffering = Boolean(result?.data?.[0]?.source_offering_nm)
            if (!this.isOffering) {
              this.resetPackage();
              this.resetMethodAndFunction();
              this.resetValues = true;
            } else {
              this.resetValues = false;
              this.getOfferingByPortfolioSub(
                result?.data?.[0]?.portfolio_id,
                result?.data?.[0]?.source_offering_nm,
                true
              );
            }
        }
        if(!res.data || res.data.length<1){
          // this.noOfferings = true;
          this.noOfferingsMsg= "";
        } else {
          this.data.activeOffering = res.data;
          if (this.data.from != DOWNLOAD_REPORTS)
          {
          this.data.selectedOffering = res?.data?.map(item =>{
            if(this.parentId && (item.packageId==this.parentId || item.package_id == this.parentId)){
                  this.data.userPrefOffering = item.packageName;
                  this.packageAdminPackageId = item?.packageId;
                }
            return item.packageName;
          })
          this.selectOfferingCopy = [...this.data.selectedOffering];
          if (!this.isPortfolio || !this.isOffering) {
            this.resetMethodAndFunction();
            this.resetPackage();
          }
        }
          else
          {
          this.sharedService.getPackagesAndProjectStatuses().subscribe(dt => {
            this.projectPackagesAndStatus.packages.packageList =  dt.offerings.map(_ => {return  {name: _.packageName,completed: true}})
            this.projectPackagesAndStatus.statusOfProjects.projectStatus = dt.projectStatuses.map(_ => {return {status: _,completed:_=="APPROVED" ? true :false,displayText: this.convertToCamelCase(_)}})
        })
          this.sharedService.getTypesOfReports().subscribe(_ => {
            _.forEach((__,ind) => {
                if (!ind)
                this.projectPackagesAndStatus.typeOfReports.currentSelected = __.requestType
                this.projectPackagesAndStatus.typeOfReports.data.push({name: __.requestType,active: true})
            })
          })
          }
        }

        if(this.data.userPrefOffering && this.data.userPrefPackage && this.data.userPrefFunction){
          this.hideMessage(true);
          this.userPrefDataFound = true;
        }
        if(this.parentId) this.getPackages("");
      }, (error) => {
        console.log(error);
        this.userPrefDataFound = false;
      });
    } 
    this.getUserProjectRole(this.data.currentProjectId, this.data.userId).subscribe();
  }

  getUserProjectRole(projectId: string, userId: string): Observable<string> {
    return this.toolsAcceleratorsControlsService.getdfteTools(projectId).pipe(
      switchMap((response: any) => {
        this.checkdisableRequest(response);
        const tool = response?.data?.find(tool => tool.entityName.toLowerCase() === ENTERPRISE_CONSCIOUSNESS.toLowerCase());
      //Added this condition to avoid calling the API when tool is not EC
        if (!tool?.entityId && tool.entityName.toLowerCase() !== ENTERPRISE_CONSCIOUSNESS.toLowerCase()) return [null];
        return this.toolsAcceleratorsControlsService.getECUsersData(projectId, tool?.entityId);
      }),
      map((response: any) => {
        const user = response.data.find(user => user.userId === userId);
        this.isProjectUser = user?.projectRole.toLowerCase() === USERROLES.PROJECTUSER.toLowerCase();
        return user?.projectRole || null;
      })
    );
  }


  checkdisableRequest(response): boolean {
      // First get approved tools from target tools (ALM, JIRA, PMOne)
      const targetTools = [this.ALM, this.Jira, this.SmartPMO];

      const approvedTargetTools = response?.data?.filter(tool =>
        targetTools.includes(tool.entityName) &&
        tool?.status?.toLowerCase() === 'approved'
      ) || [];

      // If no approved tools, don't disable
      if (approvedTargetTools.length === 0) {
        this.isRequestDisabled = false;
        return false;
      }

      // Disable button only if ALL approved tools have null/undefined attribute8
      this.isRequestDisabled = approvedTargetTools.every(tool => tool.attribute8 === null || tool.attribute8 === undefined);
    }

   


  getSourceMSTeamsSize(projectId: number): void {
    this.sharedService.getSourceMSTeamsSize(projectId).subscribe(
      (response: any) => {
        console.log('API response:', response);
        // Handle the response as needed
        if (response.status === 200 && response.data) {
          this.ascendGenerativeAISize = response.data.AscendGenerativeAISize;
          this.sourceTeamName = response.data.sourceTeamName;
          this.isMoreThan10GB = response.data.isMoreThan10GB;
          this.IsCurrentMSTeamsOwner = response.data.IsCurrentMSTeamsOwner;
          this.IsGenerativeAIFolderFound = response.data.IsGenerativeAIFolderFound;
          this.isMoreThan10GB && this.getDocumentUrl();
          this.isAscendContentDeliverableTemplateFolderFound = response.data.IsAscendContentDeliverableTemplateFolderFound;
          this.isAIPEnabled = response.data.isAIPEnabled;
          this.ascendContentSize = response.data.AscendContentSize;
        }
      },
      (error) => {
        console.error('API error:', error);
        // Handle the error as needed
      }
    );
  }

  getConfirmMsteamsData(projectId: number): void {
    this.sharedService.getConfirmMsteamsData(projectId).subscribe(
      (response: any) => {
        console.log('API response:', response);
        // Handle the response as needed
        if (response.status === 200 && response.data) {
          this.transferDataFromMsTeamName = response.data.sourceChannelName;
          this.transferDataToMsTeamName = response.data.targetChannelName;
          this.currentGroupId = response.data.currentGroupId;
          this.targetGroupId = response.data.targetGroupId;
          this.IsCurrentMSTeamsOwner = response.data.IssourceOwner ?? false;
          this.IsTargetSiteOwner = response.data.IsTargetOwner ?? false;
        }
      },
      (error) => {
        console.error('API error:', error);
        // Handle the error as needed
      }
    );

  }

  filterOwenedChannels(event: any): void {
    const filterValue = event?.target?.value?.toLowerCase();
    this.filteredChannels = this.msTeamsChannels?.filter(channel => channel?.toLowerCase()?.startsWith(filterValue));
    this.isDropdownOpen = true;
  }
  getOwnedChannels(){
    this.isDropdownOpen = false;
    this.isDataFetchingInProgress = true;
    this.showLoader = true;
    this.filteredChannels = [];
    this.sharedService.getOwenedTeamChannels().subscribe((data) => {
      data.data.forEach(element => {
        this.ownedChannels.push({id:element.id,channel:element.displayName})
      });
      this.isDataFetchingInProgress = false;
      this.showLoader = false;
      this.msTeamsChannels = data.data.map(element => element.displayName);
      this.filteredChannels = data.data.map(element => element.displayName);
    });
  }
  onPanelFocus(text: any) {
    if (!text) {
      if (!this.filteredChannels)
        this.filteredChannels = this.filteredChannels;
      else
        this.isDropdownOpen = true;
    }
    else{
      this.filteredChannels = this.filteredChannels.filter(item => item === text)
      this.isDropdownOpen = false;
      this.isChannelSelected = this.filteredChannels.length > 0;
    }
  }
  onBlur(event: any): void {
    const value = event.target.value;
      this.filteredChannelsMsSweep = this.filteredChannels.filter(item => item === value)
      this.isChannelSelected = this.filteredChannelsMsSweep.length > 0;

  }

  msChannelForm(){
    this.channelForm = this.formBuilder.group({
      msChannel: ['']
    });
  }
  onPanelClosed() {
    this.isDropdownOpen = false;
    const option = this.channelForm?.controls['msChannel']?.value;
    if (!this.msTeamsChannels.includes(option) ) {
      //this.channelForm?.controls['msChannel']?.setErrors(Validators.required)
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

isOptionSelected(option: string): boolean {
    let value = this.channelForm?.controls['msChannel']?.value;
    return false
 }
  onMsChannelSelect(value: string)
  {

   this.groupChannelId = this.ownedChannels.find(_ => _.channel == value)?.id;
   if(this.groupChannelId)
    {
      this.isChannelSelected = true;
      this.selectedMsChannel = this.groupChannelId;
    }
  }
  onMsSweepChannelSelect(value: string)
  {
    this.groupChannelId = this.ownedChannels.find(_ => _.channel == value)?.id;
    if(this.groupChannelId)
     {
       this.isChannelSelected = true;
       this.selectedMsChannel = this.groupChannelId;
     }
  }
  onCheckboxChange(event: any): void {
    this.isManualCopy = event;
    this.isDataMigrated = event
  }
  onCheckboxConfirmChange(event: any): void {
    this.isDataMigratedConfirm = event;

  }

  radioButtonChanged(e){
    let radioValue = e.value
     if(radioValue =="2"){
       this.ishidden = true;
       this.isChannelSelected = false;
       this.channelType="2"
       this.isDropdownOpen = false;
       this.getOwnedChannels();
     }
     else{
       this.ishidden = false;
       this.isChannelSelected = true;
       this.channelType="1"
     }
  }
  getPackages(offering) {
    if(offering){
      this.data.userPrefFunction= null;
      this.data.userPrefPackage = ""
      this.data.selectedFunctions = null;
      this.data.activeOffering.filter(item => {
        if(item.packageName === offering) {
          this.parentId = item.packageId;
        }
      });
     if (this.data.from === USER_PREFERENCES) {
       this.parentId = this.packageByOffering.find(
         (item: IPackageData) => offering === item.display_nm
       )?.packageId;
     }
    }
    this.userPreference.getUserPreferences(this.parentId).subscribe(response => {
      if (!response.data || response.data.length == 0) {
        this.noPublishedPackage = true;
        this.noPublishedPkgMsg =
          "No Package Method available for selection. Please publish a Package Method.";
          this.hideApplyBtn = false;
          this.data.selectedPackage = []
      } else {
        this.noPublishedPackage = false;
        if(response.data) {
        this.data.activePackages = response?.data;
        this.data.selectedPackage = response.data?.map(function (item) {
          return {name : item.name, display_nm: item.display_nm};
        });
      }
      if(this.data.selectedPackage.length==1) {
        this.data.userPrefPackage =  this.data.selectedPackage[0]?.name;
        this.getReleventFunctions(this.data.userPrefPackage);
      }
      if (this.userPrefDataFound && this.data.userPrefPackage && !this.noPublishedPackage) {
        this.getReleventFunctions(this.data.userPrefPackage);
      } else if(!this.data?.selectedPackage?.length) {
        this.userPrefDataFound = false;
      }
      if(!this.data?.userPrefPackage && !this.noPublishedPackage){
        this.hideApplyBtn = false;
      }
      if (!this.isPortfolio || !this.isOffering) {
        this.resetPackage();
        this.resetMethodAndFunction();
      }
    }
    }, (error) => {
      console.log('error');
    });
  }
  closePopup() {
    let ProjectStatus = this.cryptUtilService.getItem(
      "PROJECT_STATUS",
      "LOCAL"
    );
    if(this.data.from == 'CREATE_PROJECT' && ProjectStatus === PROJECT_STATUS?.APPROVED) {      
      this.goToMyPrjectsPage();     
    }
    this.dialogRef.close();
    this.sharedService.setRetryTool('');
  }
 closeMSChannelPopup(){
  let teamsData={channelType:this.channelType,groupId:this.selectedMsChannel}
  return this.dialogRef.close(teamsData)
 }
 closeMSSwapChannelPopup(){
  this.sharedService.getTargetSiteOwner(this.selectedMsChannel).subscribe(
    (response: any) => {
      console.log('API response:', response);
      // Handle the response as needed
      if (response.status === 200 && response.data) {
        this.IsTargetSiteOwner = response.data.IsTargetSiteOwner;
        if(this.IsTargetSiteOwner){
          let teamsData={isManualCopy:this.isManualCopy,groupId:this.selectedMsChannel}
          return this.dialogRef.close(teamsData)
          // this.dialogRef.close(true);
        }
      }
    },
    (error) => {
      console.error('API error:', error);
      // Handle the error as needed
    }
  );
  }

  closeMSSwapConfirmChannelPopup(){
    let teamsData={isManualCopy:true,groupId:this.targetGroupId}
    return this.dialogRef.close(teamsData)
    }


  close() {
    if(this.data.from == PROJECT_USERS_DELETE)
      return this.dialogRef.close(false);
    else if(this.data.from == DELETE_ALL_NOTIFICATIONS) {
      return this.dialogRef.close(true);
    }

    if (this.data.from == 'CREATE PROJECT') {
      this.location.back();
    } else if (this.data.from == 'GENERATE SCOPE') {
      this.router.navigate(['/project/list']);
    } else if (this.noPublishedPackage && this.router.url =='/welcome') {
      this.router.navigate(['/workspace/my-projects']);
    }

    this.dialogRef.close(true);
  }

  closeAndOpenModal(data: any) {
    this.dialogRef.close(data);
  }

  isToolMutuallyExcluded(item: any): boolean {
    if (!this.data?.requestToolData) return false;
    const title = item?.title;
    const releaseTools = this.data?.releaseSetupToolNames || [];
    if (title === this.SAPCALM) {
      return releaseTools.includes(this.EC) || !!this.data.requestToolData.find(t => t.title === this.EC && t.statusProvision);
    }
    if (title === this.EC) {
      return releaseTools.includes(this.SAPCALM) || !!this.data.requestToolData.find(t => t.title === this.SAPCALM && t.statusProvision);
    }
    return false;
  }

  getMutualExclusionTooltip(item: any): string {
    if (!this.isToolMutuallyExcluded(item)) return '';
    return item?.title === this.SAPCALM
      ? this.translate.instant('Activities.ToolsProvision.SAPCalm.BlockedByEC')
      : this.translate.instant('Activities.ToolsProvision.EC.BlockedBySAPCalm');
  }

  discard() {
    let ProjectStatus = this.cryptUtilService.getItem(
      "PROJECT_STATUS",
      "LOCAL"
    );
    if (this.data.from == 'CREATE_PROJECT' && this.data?.identifier == 'Unsaved Project') {

      if (this.data.from == 'CREATE_PROJECT' && this.data.tabChange == 1) {
        this.createProjServ.setCreateFormDetail(undefined);
        this.router.navigate(['/workspace/my-projects']);
        this.dialogRef.close(true);
      } else if (this.data.from == 'CREATE_PROJECT' && this.data.tabChange == 2) {
        this.createProjServ.setCreateFormDetail(undefined);
        this.createProjServ.getNavigationName.next(2);
        this.dialogRef.close(true);
      } else if (this.data.from == 'CREATE_PROJECT' && this.data.tabChange == 3) {
        this.createProjServ.setCreateFormDetail(undefined);
        this.createProjServ.getNavigationName.next(3);
        this.dialogRef.close(true);
      } else if (this.data.from == 'CREATE_PROJECT' && this.data.tabChange == 'exploreMode') {
        this.createProjServ.setCreateFormDetail(undefined);
        this.createProjServ.getNavigationName.next('exploreMode');
        this.dialogRef.close(true);
      } else if (this.data.from == 'CREATE_PROJECT' && this.data.tabChange == 'siteMap') {
        this.createProjServ.setCreateFormDetail(undefined);
        this.createProjServ.getNavigationName.next('siteMap');
        this.dialogRef.close(true);
      } else if (this.data.from == 'CREATE_PROJECT' && this.data.tabChange == 'learnAbtAscend') {
        this.createProjServ.setCreateFormDetail(undefined);
        this.createProjServ.getNavigationName.next('learnAbtAscend');
        this.dialogRef.close(true);
      } else if (this.data.from == 'CREATE_PROJECT' && this.data.tabChange == 'home') {
        this.createProjServ.setCreateFormDetail(undefined);
        this.createProjServ.getNavigationName.next('home');
        this.dialogRef.close(true);
      } else {
        this.createProjServ.setCreateFormDetail(undefined);
        this.router.navigate(['/workspace/my-projects']);
        this.dialogRef.close(true);
      }
    }
    else if(this.data.from == 'CREATE_PROJECT' && ProjectStatus === PROJECT_STATUS?.APPROVED) {      
      this.goToMyPrjectsPage();     
    }
     else {
      this.dialogRef.close(false);
    }
  }

   goToMyPrjectsPage() {
    this.cryptUtilService.setItem("PROJECT_STATUS", null, "LOCAL");     
      if(this.current_instance !== US_REGION) {
        let url = '/workspace/my-projects'
        window.location.href = `${this.primaryRedirectionUrl}/${url}`;
      }
      this.router.navigate(['/workspace/my-projects']);
      this.dialogRef.close(false);
    }

  apply(packageSelected, functionSelected, offeringSelected) {
    let selectedPackageId, selectedFunctionId, selectedParentPackageId, display_nm;
    this.data.activePackages?.forEach(packageName => {
      if (packageName.name == packageSelected) {
        selectedPackageId = packageName.package_id;
        display_nm = packageName.display_nm;
      }
    })

    selectedParentPackageId = this.parentId;
    this.data.activeFunctions?.forEach(functionName => {
      if (functionName.service_name == functionSelected) {
        selectedFunctionId = functionName.id;
      }
    })
    let obj = {
      portfolioId:
        this.portFolioId ||
        this.filteredPortfolio.find(
          (portfolio: IOfferingPortfolio) =>
            portfolio.portfolio_nm === this.form.get("portfolio")?.value
        )?.portfolio_id,
      offeringId:
        this.offeringId ||
        this.offeringData.find(
          (offering: ISourceOffering) =>
            offering.source_offering_nm === this.form.get("offering")?.value
        )?.source_offering_id,
      userId: this.data.userId,
      packageId: selectedParentPackageId,
      packageName: offeringSelected,
      methodId: selectedPackageId,
      methodName: packageSelected,
      functionId: selectedFunctionId ? selectedFunctionId: null,
      functionName: functionSelected
    }

    if (this.isPackageAdmin && (+this.packageAdminPackageId != selectedParentPackageId)){
        this.isPackageAdminOfferingMappingError = true;
    }
    else {
    this.userPreference.saveUserPreferences(obj).subscribe(data => {
      if (data.status == 201) {
        this.sendPackageData(packageSelected);
        this.sendFunctionData(functionSelected);
        this.sendPackageIdData(selectedPackageId);
        this.sendFunctionIdData(selectedFunctionId);
        this.sendParentPackageData(offeringSelected);
        this.sendParentPackageIdData(this.parentId);
        this.cryptUtilService.setItem('Previous-Session-Package-Selected-IIDR-Explore', packageSelected, 'SESSION');
        this.cryptUtilService.setItem('Previous-Session-Function-Selected-IIDR-Explore', functionSelected, 'SESSION');
        this.cryptUtilService.setItem('Previous-Session-Offering-Selected-IIDR-Explore', offeringSelected, 'SESSION');
        this.cryptUtilService.setItem('Previous-Session-Taxonomy-Selected-IIDR-Explore', null, 'SESSION');
        this.userPreference.sendTaxonomyIdData(null);
        this.cryptUtilService.setItem("function-value-selected", functionSelected, "SESSION");
        forkJoin({ response: this.adminManagementService.getUser(this.data.userId, this.languageId), result: this.myProjectsService.getMasterUserRole(LANGUAGE_DATA.ENGLISH) }).subscribe(({ response, result }) => {
          this.masterUserRoledata = result?.data;
          if(response) {

          let userRoleInfoObj = {
            userEmail: response.userEmail,
            role: response?.role?.length && response?.role[0],
            menu: response.menu,
            package: response?.package?.length && response?.package,
            roleSubset: response?.roleSubset,
            accessObjects: response?.accessObjects,
            englishLanguage: this.masterUserRoledata.find(ele => {
              return ele?.id === response?.role?.[0]?.id
          })
        }

        this.projectGlobalInfo.userRoleInfo = userRoleInfoObj;
        this.globalData.updateGlobalData(this.projectGlobalInfo);
      }
        });
        if(this.router.url =='/welcome')
        this.router.navigate(['/workspace/my-projects']);
      if(this.router.url =='/workspace/my-projects')
        this.reloadMyProjects();

      }
      let useRPrefObj = {...obj, parentPackageId: this.parentId,
        parentPackageName: offeringSelected, display_nm: display_nm};
      this.userPreference.updateData(useRPrefObj);
      this.cryptUtilService.setItem("Session-Sitemap-Filter", "", "SESSION");
      this.cryptUtilService.setItem("Session-Sitemap-Filter-Attributes", null, "SESSION");
      this.cryptUtilService.setItem("Session-Sitemap-Filter-Amplifiers", null, "SESSION");
    });

    this.dialogRef.close(true);
    this.globalSubscription.push(
    this.globalData.exploreViewUserPref.subscribe(data => {
      if (data == 'IIDRView') {
        { this.router.navigate(['/iidr']); }
      }
    }));
    this.globalData.workspaceViewUserPref.subscribe(dataView => {
      if (dataView == 'WorkspaceView') { this.router.navigate(['/workspace/my-projects']); }

    });
    }
  }

  reloadMyProjects() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  closePopupFinalizeSprint() {
    this.dialogRef.close(false);
  }
  performAction() {
    this.dialogRef.close('action');
  }

  originalOrder(a: KeyValue<number, string>, b: KeyValue<number, string>): number {
    return 0;
  }

  getActiveFunctionsData() {
    this.hideApplyBtn = false;
    //this.data.messageText = this.dialogMessage;
    if (this.router.url == '/welcome') {
      this.hideCancelBtn = false;
    }
  }

  getReleventFunctions(packageName) {
    this.data.selectedFunctions = [];
    let packageId;
    this.data.activePackages.filter(function (item) {
      if (packageName == item.name) {
        packageId = item.package_id;
      }
    });
    this.userPreference.getUserPackageFunction(packageId)
      .subscribe((data) => {
        this.data.activeFunctions = data.data;
        let newScopes = [];
        if (data) {
          data.data.forEach(element => {
            newScopes.push(element.service_name)
          });
        }
        this.data.selectedFunctions = newScopes;
        if(this.data.selectedFunctions.includes(this.data.userPrefFunction))
        this.hideApplyBtn = true;
      }, (error) => {
        this.data.selectedFunctions = this.data.selectedFunctions;
      })
    //  }
    this.getActiveFunctionsData();
  }

  hideMessage(functionName) {
    if (functionName) {
      this.data.messageText = '';
      this.hideApplyBtn = true;
      if (this.router.url == '/welcome') {
        this.hideCancelBtn = true;
      }
    }
  }

  sendPackageData(p: any) {
    this.userPreference.sendPackageData(p);
  }

  sendFunctionData(f: any) {
    this.userPreference.sendFunctionData(f);
  }

  sendParentPackageData(o: any) {
    this.userPreference.sendOfferingData(o);
  }

  sendParentPackageIdData(oId: any) {
    this.userPreference.sendOfferingIdData(oId)
  }

  sendPackageIdData(pId: any) {
    this.userPreference.sendPackageIdData(pId);
  }

  sendFunctionIdData(fId: any) {
    this.userPreference.sendFunctionIdData(fId);
  }

  deleteProjectUser(projectId, userId, deleteUserId) {
    let obj = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: {
        "projectId": projectId,
        "userId": userId,
        "deleteUserId": deleteUserId,
        "isMultipleDelete": this.data.isMultipleDelete
      }
    };

    this.myProjectsService.deleteProjectUser(obj,this.isMasterProject).subscribe((response) => {
      this.dialogRef.close(true);
    })
  }

  softDeleteProject(projectId, userId) {
    let obj = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: {
        "project_id": projectId,

        "user_id": userId
      }
    };
    const api_base_url = this.data.apiURL + '/Project/api/v1';
    this.myProjectsService.softDeleteProject(obj,api_base_url).subscribe((response) => {
      this.dialogRef.close('delete');
    })
  }

  deleteAdmin(userId) {
    let obj = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: {
        "userId": this.data?.userId,
        "deleteUserId": this.data?.deleteAdminId
      }
    };
    this.myProjectsService.deleteAdminUser(obj).subscribe(adminData => {
      if (adminData["status"] == 200) {
      }
    });
    this.dialogRef.close(true);
  }

  ngOnDestroy() {
    this.globalSubscription?.forEach(sub => {
      sub.unsubscribe();
    })
    clearInterval(this.reportPollingTimer)
  }
  downloadReportOnClick(){
    const currentSelections = this.projectPackagesAndStatus;
    let body = {
        reportType: currentSelections.typeOfReports.currentSelected,
        createdOn: new Date(),
        reportFilters: {
          offerings: (currentSelections.packages.packageList.filter(_ => _.completed == true)).map(_ => _.name),
          projectStatuses: (currentSelections.statusOfProjects.projectStatus.filter(_ => _.completed == true)).map(_ => _.status),
          startDate: currentSelections.selectedStartDate || new Date('02/01/2000 00:00:00Z'),
          endDate: currentSelections.selectedEndDate || new Date('12/31/9999 00:00:00Z'),
          ReportRequestId: 0,
        },
        requestedBy: this.data.userId,
        reportStatus : "New"
    }
    this.sharedService.requestReportDownload(body).subscribe(_ => {
      this.scrollToTop()
      let reportRequestId = _
      this.reportPollingTimer =  this.sharedService.lookForReport(reportRequestId)
    },_ => {
      this.globalContext.setNewReport({active: true, status: 'ERROR'})
      this.scrollToTop()
    })
    this.globalContext.setNewReport({active: true,status: 'GENERATE'})
    this.dialogRef.close();
  }
  getTootipTextForExtra(selection: string)
  {
    let result = ''
    if (selection == SELECT_TYPE_STATUS)
    {
        result += 'Project Statuses\n'
        this.projectPackagesAndStatus.statusOfProjects.projectStatus.forEach(_ => {
            if (_.completed)
              result += `• ${_.displayText}\n`
        })
    }
    else
    {
      result += 'Offering/Package\n'
      this.projectPackagesAndStatus.packages.packageList.forEach(_ => {
          if (_.completed)
            result += `• ${_.name}\n`
      })
    }
    return result
  }
  validateReportInput()
  {
    const packageType = this.projectPackagesAndStatus.packages
    const statusType = this.projectPackagesAndStatus.statusOfProjects
    const dateType = this.projectPackagesAndStatus.dateRangeOfReports
    let packageValid = false,statusValid = false,dateValid = false
    //package validation
    if (packageType.allCompleted || (!packageType.packageList.every(dt => dt.completed == false)))
    {
    packageValid = true
    this.projectPackagesAndStatus.currentPackage = ['projectPackagesAndStatus.packages.allCompleted']
    }
    else
    {
      this.projectPackagesAndStatus.currentPackage = []
    }
    //Status validation
    if (packageValid && (statusType.allCompleted || (!statusType.projectStatus.every(dt => dt.completed == false))))
    {
       statusValid = true
       this.projectPackagesAndStatus.currentStatus = ['projectPackagesAndStatus.statusOfProjects.allCompleted']
    }
    else
    {
      this.projectPackagesAndStatus.currentStatus = []
    }

    //Date validation and setting min max date
    const currentStartDate = Object.prototype.toString.call(new Date((this.projectPackagesAndStatus.selectedStartDate as any)))
     const currentEndDate = Object.prototype.toString.call(new Date((this.projectPackagesAndStatus.selectedEndDate as any)))
      if ((packageValid && statusValid) && (dateType.currentSelected == dateType.data[0] || ((currentStartDate == "[object Date]"  && currentEndDate  == "[object Date]") && (new Date((this.projectPackagesAndStatus.selectedStartDate as any)) < new Date((this.projectPackagesAndStatus.selectedEndDate as any))))))
        dateValid = true
    //Assign proper validation
    if (!packageValid)
        this.projectPackagesAndStatus.currentValidationError = validationMessages.noOfferings
    else if (!statusValid)
        this.projectPackagesAndStatus.currentValidationError = validationMessages.noStatuses
    else if (!dateValid)
        this.projectPackagesAndStatus.currentValidationError = validationMessages.noDate

    if (packageValid && statusValid && dateValid)
    this.projectPackagesAndStatus.enableDownloadButton = true
    else
    this.projectPackagesAndStatus.enableDownloadButton = false
  }
  changeDate(typeOfDate: string)
  {
      if (typeOfDate == 'start')
      this.projectPackagesAndStatus.endDate.minDate = new Date(this.projectPackagesAndStatus.selectedStartDate)
      else
      this.projectPackagesAndStatus.startDate.maxDate = new Date(this.projectPackagesAndStatus.selectedEndDate)
      this.validateReportInput();
  }
  getTotalSelected(selection: string){
    if (selection == SELECT_TYPE_STATUS)
    return this.projectPackagesAndStatus.statusOfProjects.projectStatus.filter(_ => _.completed == true).length
    return this.projectPackagesAndStatus.packages.packageList.filter(_ => _.completed == true).length

  }
  getOnlySelected(selection: string){
    if (selection == SELECT_TYPE_STATUS)
    return this.projectPackagesAndStatus.statusOfProjects.projectStatus.filter(_ => _.completed == true)
    return this.projectPackagesAndStatus.packages.packageList.filter(_ => _.completed == true)
  }
  checkSelectedStatus(selectType: string)
  {
    this.validateReportInput()
    if (selectType == SELECT_TYPE_STATUS)
    return this.projectPackagesAndStatus.statusOfProjects.projectStatus.filter(_ => _.completed).length > 0 && !this.projectPackagesAndStatus.statusOfProjects.allCompleted
    return this.projectPackagesAndStatus.packages.packageList.filter(_ => _.completed).length > 0 && !this.projectPackagesAndStatus.packages.allCompleted

  }
  selectAllStatus(checked: boolean,selectType: string)
  {
    if (selectType == SELECT_TYPE_STATUS)
    {
      this.projectPackagesAndStatus.statusOfProjects.allCompleted = checked
      this.projectPackagesAndStatus.statusOfProjects.projectStatus.forEach(st => (st.completed = checked))
    }
    else
    {
      this.projectPackagesAndStatus.packages.allCompleted = checked
      this.projectPackagesAndStatus.packages.packageList.forEach(st => (st.completed = checked))
    }
    this.validateReportInput()
  }
  updateAllCompleted(selectType: string)
  {
    if (selectType == SELECT_TYPE_STATUS)
    this.projectPackagesAndStatus.statusOfProjects.allCompleted = this.projectPackagesAndStatus.statusOfProjects.projectStatus.every(_ => _.completed)
    else
    this.projectPackagesAndStatus.packages.allCompleted = this.projectPackagesAndStatus.packages.packageList.every(_ => _.completed)
    this.validateReportInput()
  }
  removeChip(chipName: string,selectType: string)
  {
    if (selectType == SELECT_TYPE_STATUS)
    {
      this.projectPackagesAndStatus.statusOfProjects.projectStatus.forEach(target => {
        if (target.status == chipName)
        target.completed = false
      })
      this.projectPackagesAndStatus.statusOfProjects.allCompleted = false
    }
    else
    {
    this.projectPackagesAndStatus.packages.packageList.forEach(target => {
      if (target.name == chipName)
      target.completed = false
    })
    this.projectPackagesAndStatus.packages.allCompleted = false
    }
  }
  convertToCamelCase(input){
    const words = (input == "HARD_DELETE" ? "DELETED" :input).toLowerCase().split('_');
    for (let i = 0;i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    return words.join(' ')
  }
  scrollToTop()
  {
    setTimeout(_ => document.querySelector('#container_layout').scrollTo(0,0),300)
  }

  /**
  * DownloadManual: method will download the document whose
  * url was obtained by function getDocumentUrl
  */
  downloadDocument = () => {
      const url = this.manualUrl;

      this.sharedService.downloadDocument(url).subscribe(blob => {
        saveAs(blob, this.fileName);
      }); 
  };

  /**
  * getDocumentUrl gets the url of document which will be 
  * downloaded by function downloadManual
  */
  getDocumentUrl = () => {
    this.sharedService.getDownloadDocumentUrl().subscribe((res: IDocumentUrl) => {
      const status = res?.status
      const downloadUrl = res?.data?.downloadUrl
      this.fileName = res?.data?.fileName
      const data = res?.data

      if (status === 200 && data) {
        this.manualUrl = downloadUrl;
        this.isManualUrl = true;
      } else {
        this.isManualUrl = false;
      }
    });
  };

  getTileIcon(toolName)
  {
    switch(toolName){
      case this.SmartPMO:
        return 'assets/trainstop/pmone.svg';
      case this.EC:
        return 'assets/trainstop/EconImg.svg';
      case this.ALM:
          return 'assets/trainstop/ALMImg.svg';
      case this.Jira:
        return 'assets/trainstop/JiraImg.svg';
      case this.msTeams:
        return 'assets/trainstop/TeamsImg.svg';
      case this.SAPCALM:
        return 'assets/trainstop/SAPCALMImg.svg';
      default:
        return 'assets/psg/deloitte.png';
    }
  }

  /**
   * Fetches the list of portfolios and updates the filteredPortfolio array.
   */
  getPortFoliosList = () => {
    this.userPreference
      .getPotfolioList()
      .subscribe((res: IOfferingPortfolioResponse) => {
        res.status === 200
          ? (this.filteredPortfolio = res.data)
          : (this.filteredPortfolio = []);
      });
  };

  /**
   * Fetches offerings by portfolio ID and updates the component's offering data.
   *
   * @param {number} portFolioId - The ID of the portfolio to fetch offerings for.
   * @param offeringName - The name of the offering to be set (optional).
   * @param isFirstTime - The parameter for checking the first time (optional).
   */
  getOfferingByPortfolioSub(
    portFolioId: number,
    offeringName: string = undefined,
    isFirstTime = false
  ) {
    if (portFolioId) {
      this.userPreference
        .getOfferingbyPortfolio(portFolioId)
        .subscribe((res: ISourceOfferingResponse) => {
          res.status === 200
            ? (this.offeringData = res.data)
            : (this.offeringData = []);
          if (offeringName && offeringName.length > 1) {
            this.form.get("offering").enable();
            this.form.get("offering").setValue(offeringName);

            if (isFirstTime) {
              this.l2Code = this.offeringData.find(
                (offering: ISourceOffering) =>
                  offering.source_offering_nm === offeringName
              )?.l2_code;
              this.getPackagesByOffering();
            }
          }
        });
    }
  }

  /**
   * Handles the selection of a portfolio and fetches the corresponding offerings.
   * @param option - The selected portfolio option.
   */
  selectedPortfolio = (option: IOfferingPortfolio) => {
    this.resetValues = true;
    this.getOfferingByPortfolioSub(option.portfolio_id);
    this.portFolioId = option.portfolio_id;
    this.l1Code = option.l1_code;
    this.isPortfolio = true;
    this.form
      .get("portfolio")
      .setValue(option.portfolio_nm, { emitEvent: false });
    this.form
      .get("portfolio")
      .updateValueAndValidity({ onlySelf: true, emitEvent: true });
  };

  /**
   * Handles the selection of an offering.
   *
   * @param option - The selected offering option.
   * @param option.source_offering_id - The ID of the source offering.
   * @param option.l2_code - The L2 code of the offering.
   */
  selectedOffering = (option: ISourceOffering) => {
    this.resetValues = true;
    this.offeringId = option.source_offering_id;
    this.l2Code = option.l2_code;
    this.isOffering = true;
    this.getPackagesByOffering();
    this.form
      .get("offering")
      .setValue(option.source_offering_nm, { emitEvent: false });
    this.form
      .get("offering")
      .updateValueAndValidity({ onlySelf: true, emitEvent: true });
  };

  /**
   * Resets the package by clearing user preferences and selected offerings.
   *
   * This method performs the following actions:
   * - Sets `userPrefOffering` to `null`.
   * - Sets `noOfferings` to `true`.
   * - Clears the `selectedOffering` array.
   */
  resetPackage = () => {
    this.noPublishedPkgMsg = "";
    this.data.userPrefOffering = null;
    this.noOfferings = true;
    this.data.selectedOffering = [];
    this.hideApplyBtn = false;
  };

  /**
   * Resets the method and function selections by clearing user preferences and selected packages/functions.
   */
  resetMethodAndFunction = () => {
    this.data.userPrefPackage = "";
    this.data.selectedPackage = [];
    this.data.userPrefFunction = null;
    this.data.selectedFunctions = [];
    this.hideApplyBtn = false;
    this.noPublishedPackage = true;
  };

  /**
   * Fetches packages based on the current offering codes (l1Code and l2Code) and updates
   * the selected offering data.
   */
  getPackagesByOffering = () => {
    if (this.l1Code && this.l2Code) {
      this.userPreference
        .getPackagesByOffering(this.l1Code, this.l2Code)
        .pipe(
          map((res: IPrePackageResponse) => {
            if (res?.status === 200) {
              return {
                ...res,
                data: res.data.map((item: IPrePackageData) => ({
                  packageId: item.pfm_package_id,
                  display_nm: item.pkg_package_name,
                })),
              };
            }
            return res;
          })
        )
        .subscribe((res: IPackageResponse) => {
          this.packageByOffering = res?.data;
          res?.status === 200
            ? (this.data.selectedOffering = res?.data?.map(
                (item: IPackageData) => item.display_nm
              ))
            : (this.data.selectedOffering = []);
          this.selectOfferingCopy = [...this.data.selectedOffering];
          this.noOfferings = false;
        });
    }
  };

  /**
   * Finds and assigns the L1 code of a portfolio based on the given name.
   *
   * @param name - The name of the portfolio to search for.
   */
  findL1Code = (name: string) => {
    this.l1Code = this.filteredPortfolio.find(
      (portfolio: IOfferingPortfolio) => portfolio.portfolio_nm === name
    )?.l1_code;
  };

/**
 * Handles the change event for the open state of a select component.
 *
 * @param {boolean} isOpen - The new open state of the select component.
 * @param {string} selectId - The unique identifier of the select component.
 */
onSelectOpenChange(isOpen: boolean, selectId: string) {
  this.openSelectState[selectId] = isOpen;
}

/**
 * Checks if the select dropdown with the given ID is open.
 *
 * @param selectId - The ID of the select dropdown to check.
 * @returns `true` if the select dropdown is open, `false` otherwise.
 */
isSelectOpen(selectId: string): boolean {
  return this.openSelectState[selectId] || false;
}

}